// extracted by mini-css-extract-plugin
export default {"title":"title---ut3Vm","content":"content---JLrj3"};